import React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';

export const ContactForm = () => {
  return (
    <>
      <Container maxWidth='md'>
        <Typography variant='h3' align='center' gutterBottom>
          Contact us to discuss a cleaning quote or all other inquiries
        </Typography>
        <Typography variant='body1' align='center' gutterBottom>
          Please fill out our form below and we'll aim to respond within 1-2
          working days. Please add details such as your area code, cleaning
          needs and whether you are interested in our domestic, commercial or
          bespoke cleaning services. A member of our team will respond as soon
          as possible. If you have a preferred contact method please let us
          know.
        </Typography>
      </Container>
      <Container maxWidth='md'>
        <form
          name='contact-dee'
          method='post'
          data-netlify='true'
          data-netlify-honeypot='bot-field'
          action='/success/'
          autoComplete='off'
        >
          <h2>Contact</h2>
          <input type='hidden' name='form-name' value='contact-dee' />
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                variant='outlined'
                id='email'
                name='email'
                label='Email'
                type='email'
                required
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                variant='outlined'
                id='firstName'
                name='firstName'
                label='First name'
                required
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                variant='outlined'
                id='lastName'
                name='lastName'
                label='Last name'
                required
              />
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant='caption'
                display='block'
                gutterBottom
                style={{ marginLeft: '12px' }}
              >
                The name of your business / organisation (if applicable)
              </Typography>
              <TextField
                fullWidth
                variant='outlined'
                id='company'
                name='company'
                label='Company'
              />
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant='caption'
                display='block'
                gutterBottom
                style={{ marginLeft: '12px' }}
              >
                Let us know the best number to contact you on
              </Typography>
              <TextField
                fullWidth
                variant='outlined'
                id='phone'
                name='phone'
                label='Phone number'
              />
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant='caption'
                display='block'
                gutterBottom
                style={{ marginLeft: '12px' }}
              >
                Please tell us about your cleaning needs
              </Typography>
              <TextField
                fullWidth
                id='message'
                name='message'
                label='Message'
                multiline
                rows={4}
                variant='outlined'
                required
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant='caption' display='block' gutterBottom>
                * fields are required
              </Typography>
              <Button
                variant='contained'
                color='primary'
                type='submit'
                size='large'
              >
                SUBMIT
              </Button>
            </Grid>
          </Grid>
        </form>
      </Container>
    </>
  );
};
